import React, { useEffect, useRef, useState } from "react";
import { BaseUrl } from "../../config";
import { useSelector } from "react-redux";

import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Banner } from '../../components';
import { HalfColText } from '../../components';
import { HalfColTextFlex } from '../../components';
import { RowQuotes } from '../../components';
import { GoToManifesto } from '../../components';
import { CarouselHomeNew } from '../../components';
import { InnerLink } from '../../components';
import { ClientsRow } from '../../components';
import { Loader } from '../../components';
import { HomeHeroDark } from '../../components';
import { HomeColumns } from '../../components';
import { NumbersWrap } from '../../components/';
import { NumberCell } from '../../components/';
import { NumbersRowSingle } from '../../components/';
import { ScrollingVideos } from '../../components';
import { PartnershipRow } from '../../components';
gsap.registerPlugin(ScrollTrigger);



const NewHome = (props) => {
  
  const [quotesArray, setQuotesArray] = useState([]);
  const [listClients, setListClients] = useState([]);
  const listPartners = [
    require('../../assets/clients/NRF-client.png'),
    require('../../assets/homepage-partnership/VR_AR_association.png'),
    require('../../assets/homepage-partnership/khronos_bb.png'),
    require('../../assets/homepage-partnership/Retail_institute.png'),
    require('../../assets/homepage-partnership/assolombarda.png')
  ]

  useEffect(() => {
    document.title = "The Future of VR is Now - Invrsion";
    fetch(`${BaseUrl}/feedbacks?key=invrsion`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((json) =>  {
      setQuotesArray(json.data.feedbacks);
    })

    fetch(`${BaseUrl}/page?key=invrsion&slug=home`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      
      setListClients(res.data.company.clients);
      console.log('invrsion.com')
    })
    
  }, []);


  const columnsEntries = [
    {
      title: 'Unique',
      text: 'Never before seen realism, down to every detail, that generates engagement and finally connects brands and consumers.'
    },
    {
      title: 'Fast',
      text: 'Real results are made in real-time to keep up with fast-paced industries.'
    },
    {
      title: 'Impactful',
      text: 'Make a real difference in the decision-making process to guarantee real results through lasting and unforgettable impressions.'
    }
  ]

  const heroImg = require('../../assets/image-cover-video.jpg');
 
  const arrayLoad = [
    heroImg
  ]

  return (
    
    <React.Fragment>
      
        <HomeHeroDark 
          title="Gain access to the future"
          hasClosingCopy={true}
        />
      
      <HomeColumns entries={columnsEntries} separators={true} />
      
      <ScrollingVideos />
      
      <GoToManifesto />
      
      <NumbersWrap newHome={true} paddingBottom={false}>
        <h6 className="md--title">Why you can count on Full Reality</h6>
        <NumbersRowSingle newHome={true}>
          <NumberCell 
            isImage={false} 
            newHome={true}
            bigNumber="88" 
            size="B" 
            title="Dollar estimated value" 
            text="estimated value given to the Virtual Reality market by 2025 (Mordor Intelligence)"
          />
          <NumberCell 
            isImage={false} 
            newHome={true}
            bigNumber="184" 
            size="B" 
            title="Dollar boost" 
            text="to global GDP from the use of VR and AR in the retail and consumer sector by 2030 (PwC)"
          />
        </NumbersRowSingle>
      </NumbersWrap>
      <CarouselHomeNew />

      
      <div className="paragraph--col-wrap">
        <div className="paragraph--col-big">
          <h5 className="big--title">
            Explore the industries that we upgrade with our Full Reality solutions          
          </h5>
        </div>
      </div>
      <InnerLink />
      {
        listClients.length > 0 &&
        <ClientsRow arrayClients={listClients}/>
      }
      <HalfColText >
        <div className="title--col">
          
        </div>
        {
          quotesArray.length > 0 &&
          <HalfColTextFlex>
            {
              quotesArray.map((key, index) => {
                return <RowQuotes key={index} quote={key.quote} name={key.name} company={key.company} position={key.company_role} />
              })
            }
          </HalfColTextFlex>
        }
      </HalfColText>
      
      <PartnershipRow 
        arrayPartners={listPartners} 
        title="We’re active members of recognized, top-tier associations." 
      />
    
      <Banner text="Intrigued? Let’s have a chat." route="/contact-us" copyRoute="Reach out" />
      <Loader arrayLoad={ arrayLoad } />
    </React.Fragment>
  );
};

export default NewHome;
